import { Currency } from '@/enums';

// Actual currency signs — used wherever an amount is entered/displayed
// (e.g. a price input's prefix). Currency *selection* UI (tabs, dropdowns)
// should keep showing the plain currency code (SGD, MYR, ...), not these.
export const CURRENCY_SYMBOLS: Record<Currency, string> = {
  [Currency.SGD]: 'S$',
  [Currency.HKD]: 'HK$',
  [Currency.THB]: '฿',
  [Currency.MYR]: 'RM',
  [Currency.PHP]: '₱',
  [Currency.IDR]: 'Rp',
  [Currency.VND]: '₫',
  [Currency.SAR]: '﷼',
};

export const getCurrencySymbol = (currency?: string | null): string =>
  (currency && CURRENCY_SYMBOLS[currency as Currency]) || currency || '$';
